export function formatCount(value: number): string {
  if (value >= 10000) {
    return `${(value / 10000).toFixed(1)}万`;
  }
  return value.toLocaleString('zh-CN');
}

export function formatDate(value: string): string {
  return value.replace(/-/g, '.');
}